import { createSlice } from 'utils/@reduxjs/toolkit';
import { ItemsState } from './types';
import { reducers } from './reducers';

export const initialState: ItemsState = {
  isLoading: false,
  data: {
    items: [],
    hasMore: false,
    totalCount: 0,
  },
  error: null,
};

const slice = createSlice({
  name: 'items',
  initialState,
  reducers,
});

export const { actions: itemsActions } = slice;
export const { reducer: itemsReducer } = slice;
